import * as actionTypes from '../action-types'

export const dismissNotification = key => {
  return { type: actionTypes.DISMISS_NOTIFICATION, payload: key }
}